export namespace Phase {
  export const THREE_PHASE: string[] = ["L1", "L2", "L3"];
}
